import React from "react";
//material-ui
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import { makeStyles } from "@material-ui/core/styles";
//custom components
import { CustomDialogTitle } from "components/Dialogs/CustomDialogTitle";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = makeStyles(() => ({
  dialogContent: {
    width: "100%",
    height: "100%",
  },
}));

export default function GenericDialog(props) {
  const classes = useStyles();
  const handleClose = props.onClose ?? props.handleClose;

  return (
    <Dialog
      TransitionComponent={Transition}
      fullScreen={props.fullScreen}
      fullWidth={props.fullWidth}
      maxWidth={props.maxWidth}
      open={props.open}
      onClose={handleClose}
      aria-labelledby="generic-dialog-v2"
    >
      <CustomDialogTitle onClose={handleClose} />
      <DialogContent className={classes.dialogContent}>
        {props.children}
      </DialogContent>
    </Dialog>
  );
}
